import React from 'react'
import { BoxPreview } from '../BoxEmail/styled'
import { Container } from './styled'

import imgBackground from "../../../../assets/imgs/preview-background.png";
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import { translations } from '../../../../utils/language';
import PreviewCheckout from '../preview-checkout';
import { ActionBar } from '../../../../empreenderUI/ui/ActionBar';
import { useBlockNavigation } from '../../../../empreenderUI/ui/NavigationBlocker';

const BoxCheckout = () => {
    const controlConfig = useSelector((state) => state.reducerControlConfig);
    const controlSaveCheckout = useSelector(state => state.reducerControlSaveCheckout)
    const dispatch = useDispatch()
    const language = useSelector((state) => state.reducerLanguage);

    const hasUnsavedChanges = !controlSaveCheckout;
    useBlockNavigation(hasUnsavedChanges);

    const saveConfig = () => {
        dispatch({
            type: "SAGA_UPDATE_TEMPLATE", payload: {
                id: controlConfig?.id,
                checkout_message_header: controlConfig.checkout_message_header,
                checkout_message_title: controlConfig.checkout_message_title,
                checkout_message: controlConfig.checkout_message,
                checkout_button: controlConfig.checkout_button,
                checkout_button_link: controlConfig.checkout_button_link,
                checkout_color: controlConfig.checkout_color,
            }
        })
    }

    const discardChanges = () => {
        dispatch({ type: "SAGA_GET_TEMPLATES" })
    }

    return (
        <Container>
            <BoxPreview img={imgBackground} style={{ position: "relative" }}>
                <PreviewCheckout />
            </BoxPreview>

            <ActionBar
                open={hasUnsavedChanges}
                textos={{
                    mainText: translations["thema-cuidado-salvar"][language.data],
                }}
                onSave={(proceed) => {
                    saveConfig()
                    proceed()
                }}
                onCancel={discardChanges}
            />
        </Container>
    )
}

export default BoxCheckout
